"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Token = void 0;
class Token {
    constructor(address, decimals, symbol, tokenType = 'ERC20', mainConnector = '', connectors = [], network = 1, img, allowance, balance) {
        this.address = address;
        this.decimals = decimals;
        this.symbol = symbol;
        this.tokenType = tokenType;
        this.mainConnector = mainConnector;
        this.connectors = connectors;
        this.network = network;
        this.img = img;
        this.allowance = allowance;
        this.balance = balance;
        this.connectors = this.connectors.length
            ? this.connectors
            : this.mainConnector
                ? [this.mainConnector]
                : ['ETH'];
        this.tokenType =
            this.tokenType ||
                (this.symbol && this.symbol.toUpperCase() === 'ETH' ? 'ETH' : 'ERC20');
    }
}
exports.Token = Token;
//# sourceMappingURL=token.js.map